const btnDown = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const btnDown = document.querySelector('.btn__down')
		const section = document.querySelector('.scrollTo')
		if (btnDown && section) {
			btnDown.addEventListener('click', function () {
				window.scrollTo({ top: section.offsetTop, behavior: 'smooth' })
			})
		}
	})
}
export default btnDown
